














import { Component, Vue, Prop, Provide, Watch, Emit } from 'vue-property-decorator'
import { Book } from './../model/book_model'
import { bookSeries, bookCatalog, getBooks } from './../model/api'
import { sa } from '@/utils/sa'

@Component
export default class BookTree extends Vue {
  @Prop() public checkable!: boolean
  @Prop() public track!: string
  @Prop() public data!: {
    series_id: string | number
    grade?: string | number
    bookName?: string
    gradeName?: string
  }
  @Prop({
    default() {
      return true
    }
  })
  checkStrictly!: boolean
  @Prop({
    default() {
      return { checked: [], halfChecked: [] }
    }
  })
  private getChapters!: { checked: string[] | number[]; halfChecked: string[] | number[] }
  @Prop({
    default() {
      return true
    }
  })
  private selectable!: boolean

  public loadedKeys = []
  public treeData = []
  private chapters: { checked: string[] | number[]; halfChecked: string[] | number[] } = {
    checked: [],
    halfChecked: []
  }

  private get subject() {
    return this.$store.state.subject
  }
  @Watch('data', { deep: true, immediate: true })
  onDataChange(val) {
    this.onSelect([])
    this.treeData = []
    if (val.grade) {
      this.getBookSeries({
        parent_id: val.grade
      })
    }
  }
  @Watch('chapters', { deep: true })
  onChaptersChange(val, old) {
    // 值传递
    this.onChecked(val)
    // 埋点采集
    if (!this.track) return
    setTimeout(() => {
      sa.track('ContentRepository_Top', {
        lvevl1Menu: this.track,
        lvevl2Menu: '章节',
        lvevl3Menu: [this.data.bookName, this.data.gradeName],
        subject: this.subject.label
      })
    }, 50)
  }
  @Watch('getChapters', { deep: true })
  onGetChaptersChange(val, old) {
    // 监听传入
    this.chapters = val
  }
  @Emit()
  onChecked(val) {
    return val
  }
  @Emit()
  onSelect(val) {
    return val
  }
  public mounted() {
    this.onSelect([])
  }
  /**
   * onLoadData
   */
  public async onLoadData(treeNode: any) {
    let params = {
      parent_id: treeNode.dataRef.key
    }
    if (this.checkable) {
      params.parent_id =
        -1 === treeNode.dataRef.key.indexOf('?') ? '' : treeNode.dataRef.key.split('?')[0]
    }
    let { data } = await bookCatalog(params)
    return new Promise((resolve) => {
      if (treeNode.dataRef.children) {
        resolve()
        return
      }
      if (!data || !data.length) {
        treeNode.dataRef.isLeaf = true
        this.treeData = [...this.treeData]
        resolve()
        return
      }
      treeNode.dataRef.children = this.treeDataProcess(data)
      this.treeData = [...this.treeData]
      // console.log(this.treeData)
      resolve()
    })
  }
  public treeDataProcess(data) {
    let temp: any = []
    if (data && data.length > 0) {
      for (let n of data) {
        let item: any = {}
        item.class = n.class || ''
        item.style = n.style || ''
        item.disableCheckbox = n.disableCheckbox || false
        item.disabled = n.disabled || false
        item.icon = n.icon || ''
        item.isLeaf = !n.has_child || false
        item.key = this.checkable ? n._id + `?title=${n.name}` : n._id
        item.title = n.name || ''
        // 是否可选
        if (!this.selectable) {
          item.selectable = false
        }

        temp.push(item)
      }
    }
    return temp
  }
  /**
   * getBookSeries
   */
  public async getBookSeries(val) {
    let { data } = await bookCatalog(val)
    this.treeData = this.treeDataProcess(data)
  }
  public select(val, a) {
    this.onSelect(val)
    if (!this.track) return
    setTimeout(() => {
      sa.track('ContentRepository_Top', {
        lvevl1Menu: this.track,
        lvevl2Menu: '章节',
        lvevl3Menu: [this.data.bookName, this.data.gradeName, a.node.title],
        subject: this.subject.label
      })
    }, 50)
  }
}
